var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "wrapper task-list" },
    [
      _c(
        "div",
        { staticClass: "breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { "separator-class": "el-icon-arrow-right" } },
            [
              _c(
                "el-breadcrumb-item",
                { attrs: { to: { path: "/tool/classAssign/intro" } } },
                [_vm._v("精准教学分班")]
              ),
              _c(
                "el-breadcrumb-item",
                { attrs: { to: { path: "/tool/classAssign/list" } } },
                [_vm._v("精准教学分班汇总")]
              ),
              _c("el-breadcrumb-item", [
                _vm._v(_vm._s(_vm.recordId ? "编辑" : "新增") + "记录"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c("div", { staticClass: "main" }, [
        _c("header", { staticClass: "header" }, [
          _c(
            "div",
            {
              staticClass: "back",
              on: {
                click: function ($event) {
                  return _vm.$router.back()
                },
              },
            },
            [
              _c("img", {
                attrs: { src: require("images/back.png"), width: "8" },
              }),
              _c("span", [_vm._v("返回")]),
            ]
          ),
        ]),
        _vm._m(0),
        _c("div", { staticClass: "weight" }, [
          _vm._m(1),
          _c(
            "div",
            { staticClass: "item-container" },
            _vm._l(_vm.DivideSettingVo.divideSubjects, function (s, i) {
              return _c(
                "div",
                { key: i, staticClass: "subject" },
                [
                  _c("span", [_vm._v(_vm._s(s.subjectName) + "权重排名：")]),
                  _vm._l(s.divideSubjectItems, function (d, j) {
                    return _c(
                      "span",
                      { key: d.id },
                      [
                        _c("el-tag", { key: j, attrs: { size: "small" } }, [
                          _vm._v(_vm._s(d.itemName)),
                        ]),
                        j < s.divideSubjectItems.length - 1
                          ? _c("span", [_vm._v("> ")])
                          : _vm._e(),
                      ],
                      1
                    )
                  }),
                ],
                2
              )
            }),
            0
          ),
        ]),
      ]),
      _c("div", { staticClass: "main" }, [
        _c("div", { staticClass: "title" }, [
          _c("span", [_vm._v("班级总人数：")]),
          _c("span", { staticClass: "sub_title" }, [
            _vm._v(_vm._s(_vm.DivideSettingVo.totalStudNum) + " 人"),
          ]),
        ]),
        _c(
          "div",
          { staticClass: "item-container" },
          _vm._l(_vm.DivideSettingVo.divideStudClass, function (d, i) {
            return _c("div", { key: i, staticClass: "class_num" }, [
              _vm._v(_vm._s(d.sourceName) + "班：" + _vm._s(d.studNum) + "人"),
            ])
          }),
          0
        ),
      ]),
      _vm._l(_vm.DivideSettingVo.divideRegionVos, function (r, i) {
        return _c("div", { key: i, staticClass: "main" }, [
          _c("div", { staticClass: "title" }, [
            _c("span", [_vm._v(_vm._s(r.regionName) + "：")]),
            _c("span", { staticClass: "sub_title" }, [
              _vm._v("预计人数：" + _vm._s(_vm.totalNum[i]) + "人"),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "source" },
            [
              _vm._m(2, true),
              _vm._l(_vm.DivideSettingVo.divideStudClass, function (d, j) {
                return _c(
                  "div",
                  {
                    key: j,
                    staticClass: "class_item",
                    class: { active: _vm.classSelected[i].indexOf(d.id) > -1 },
                    on: {
                      click: function ($event) {
                        return _vm.toggleClassSelected(i, d, r)
                      },
                    },
                  },
                  [_vm._v(_vm._s(d.sourceName) + "班")]
                )
              }),
            ],
            2
          ),
          _c("div", { staticClass: "level" }, [
            _vm._m(3, true),
            _c(
              "div",
              { staticClass: "class_num" },
              [
                _c("span", [_vm._v("每班人数：")]),
                _c("el-input", {
                  staticStyle: { width: "80px" },
                  attrs: { type: "number", min: 1 },
                  model: {
                    value: _vm.classNum[i],
                    callback: function ($$v) {
                      _vm.$set(_vm.classNum, i, _vm._n($$v))
                    },
                    expression: "classNum[i]",
                  },
                }),
                _c("span", [_vm._v("人")]),
              ],
              1
            ),
            _c("div", { staticClass: "level-area" }, [
              _vm.taskType != 0
                ? _c(
                    "div",
                    { staticClass: "level" },
                    [
                      _c("div", { staticClass: "label" }, [_vm._v("C+班：")]),
                      _vm._l(r.divideClassSettingVos, function (c, j) {
                        return c.type === 0
                          ? _c(
                              "div",
                              { key: j, staticClass: "item" },
                              [
                                c.editable
                                  ? _c("el-input", {
                                      staticStyle: {
                                        width: "80px",
                                        color: "#8698B7",
                                      },
                                      attrs: {
                                        placeholder: "名称",
                                        clearable: "",
                                      },
                                      on: {
                                        keyup: function ($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          ) {
                                            return null
                                          }
                                          return _vm.setClassNameDiable(
                                            c,
                                            false
                                          )
                                        },
                                        blur: function ($event) {
                                          return _vm.setClassNameDiable(
                                            c,
                                            false
                                          )
                                        },
                                      },
                                      model: {
                                        value: c.className,
                                        callback: function ($$v) {
                                          _vm.$set(c, "className", $$v)
                                        },
                                        expression: "c.className",
                                      },
                                    })
                                  : _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          cursor: "pointer",
                                          color: "#8698B7",
                                        },
                                        on: {
                                          dblclick: function ($event) {
                                            return _vm.setClassNameDiable(
                                              c,
                                              true
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v(_vm._s(c.className))]
                                    ),
                                _c("el-input", {
                                  staticStyle: {
                                    width: "60px",
                                    color: "#8698B7",
                                  },
                                  attrs: { placeholder: "人数" },
                                  model: {
                                    value: c.studNum,
                                    callback: function ($$v) {
                                      _vm.$set(c, "studNum", _vm._n($$v))
                                    },
                                    expression: "c.studNum",
                                  },
                                }),
                                _vm.taskType == 2
                                  ? _c("el-input", {
                                      staticStyle: {
                                        width: "160px",
                                        color: "#8698B7",
                                      },
                                      attrs: {
                                        type: "number",
                                        min: 0,
                                        placeholder: "总分排名限制",
                                      },
                                      model: {
                                        value: c.rankingLimit,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            c,
                                            "rankingLimit",
                                            _vm._n($$v)
                                          )
                                        },
                                        expression: "c.rankingLimit",
                                      },
                                    })
                                  : _vm._e(),
                                _c("span", { staticClass: "del-container" }, [
                                  _c("i", {
                                    staticClass: "el-icon-error",
                                    on: {
                                      click: function ($event) {
                                        return _vm.deleteClass(i, j)
                                      },
                                    },
                                  }),
                                ]),
                              ],
                              1
                            )
                          : _vm._e()
                      }),
                      _vm.plusIconVisible[i][3]
                        ? _c("span", [
                            _c("i", {
                              staticClass: "el-icon-circle-plus",
                              on: {
                                click: function ($event) {
                                  return _vm.addClass(i, 0)
                                },
                              },
                            }),
                          ])
                        : _vm._e(),
                    ],
                    2
                  )
                : _vm._e(),
              _c(
                "div",
                { staticClass: "level" },
                [
                  _c("div", { staticClass: "label" }, [_vm._v("C班：")]),
                  _vm._l(r.divideClassSettingVos, function (c, j) {
                    return c.type === 3
                      ? _c(
                          "div",
                          { key: j, staticClass: "item" },
                          [
                            c.editable
                              ? _c("el-input", {
                                  staticStyle: {
                                    width: "80px",
                                    color: "#8698B7",
                                  },
                                  attrs: { placeholder: "名称", clearable: "" },
                                  on: {
                                    keyup: function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.setClassNameDiable(c, false)
                                    },
                                    blur: function ($event) {
                                      return _vm.setClassNameDiable(c, false)
                                    },
                                  },
                                  model: {
                                    value: c.className,
                                    callback: function ($$v) {
                                      _vm.$set(c, "className", $$v)
                                    },
                                    expression: "c.className",
                                  },
                                })
                              : _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      cursor: "pointer",
                                      color: "#8698B7",
                                    },
                                    on: {
                                      dblclick: function ($event) {
                                        return _vm.setClassNameDiable(c, true)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(c.className))]
                                ),
                            _c("el-input", {
                              staticStyle: { width: "60px", color: "#8698B7" },
                              attrs: { placeholder: "人数" },
                              model: {
                                value: c.studNum,
                                callback: function ($$v) {
                                  _vm.$set(c, "studNum", _vm._n($$v))
                                },
                                expression: "c.studNum",
                              },
                            }),
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "280px" },
                                attrs: {
                                  multiple: "",
                                  placeholder: "选择班级",
                                },
                                model: {
                                  value: c.sourceNames,
                                  callback: function ($$v) {
                                    _vm.$set(c, "sourceNames", $$v)
                                  },
                                  expression: "c.sourceNames",
                                },
                              },
                              _vm._l(_vm.classObjSelected[i], function (c, k) {
                                return _c("el-option", {
                                  key: k,
                                  attrs: {
                                    label: c.sourceName,
                                    value: c.sourceName,
                                  },
                                })
                              }),
                              1
                            ),
                            _c("span", { staticClass: "del-container" }, [
                              _c("i", {
                                staticClass: "el-icon-error",
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteClass(i, j)
                                  },
                                },
                              }),
                            ]),
                          ],
                          1
                        )
                      : _vm._e()
                  }),
                  _vm.plusIconVisible[i][2]
                    ? _c("span", [
                        _c("i", {
                          staticClass: "el-icon-circle-plus",
                          on: {
                            click: function ($event) {
                              return _vm.addClass(i, 3)
                            },
                          },
                        }),
                      ])
                    : _vm._e(),
                ],
                2
              ),
              _c(
                "div",
                { staticClass: "level" },
                [
                  _c("div", { staticClass: "label" }, [_vm._v("B班：")]),
                  _vm._l(r.divideClassSettingVos, function (c, j) {
                    return c.type === 2
                      ? _c(
                          "div",
                          { key: j, staticClass: "item" },
                          [
                            c.editable
                              ? _c("el-input", {
                                  staticStyle: {
                                    width: "80px",
                                    color: "#8698B7",
                                  },
                                  attrs: { placeholder: "名称", clearable: "" },
                                  on: {
                                    keyup: function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.setClassNameDiable(c, false)
                                    },
                                    blur: function ($event) {
                                      return _vm.setClassNameDiable(c, false)
                                    },
                                  },
                                  model: {
                                    value: c.className,
                                    callback: function ($$v) {
                                      _vm.$set(c, "className", $$v)
                                    },
                                    expression: "c.className",
                                  },
                                })
                              : _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      cursor: "pointer",
                                      color: "#8698B7",
                                    },
                                    on: {
                                      dblclick: function ($event) {
                                        return _vm.setClassNameDiable(c, true)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(c.className))]
                                ),
                            _c("el-input", {
                              staticStyle: { width: "60px", color: "#8698B7" },
                              attrs: { placeholder: "人数" },
                              model: {
                                value: c.studNum,
                                callback: function ($$v) {
                                  _vm.$set(c, "studNum", _vm._n($$v))
                                },
                                expression: "c.studNum",
                              },
                            }),
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "280px" },
                                attrs: {
                                  multiple: "",
                                  placeholder: "选择班级",
                                },
                                model: {
                                  value: c.sourceNames,
                                  callback: function ($$v) {
                                    _vm.$set(c, "sourceNames", $$v)
                                  },
                                  expression: "c.sourceNames",
                                },
                              },
                              _vm._l(_vm.classObjSelected[i], function (c, k) {
                                return _c("el-option", {
                                  key: k,
                                  attrs: {
                                    label: c.sourceName,
                                    value: c.sourceName,
                                  },
                                })
                              }),
                              1
                            ),
                            _c("span", { staticClass: "del-container" }, [
                              _c("i", {
                                staticClass: "el-icon-error",
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteClass(i, j)
                                  },
                                },
                              }),
                            ]),
                          ],
                          1
                        )
                      : _vm._e()
                  }),
                  _vm.plusIconVisible[i][1]
                    ? _c("span", [
                        _c("i", {
                          staticClass: "el-icon-circle-plus",
                          on: {
                            click: function ($event) {
                              return _vm.addClass(i, 2)
                            },
                          },
                        }),
                      ])
                    : _vm._e(),
                ],
                2
              ),
              _c(
                "div",
                { staticClass: "level" },
                [
                  _c("div", { staticClass: "label" }, [_vm._v("A班：")]),
                  _vm._l(r.divideClassSettingVos, function (c, j) {
                    return c.type === 1
                      ? _c(
                          "div",
                          { key: j, staticClass: "item" },
                          [
                            c.editable
                              ? _c("el-input", {
                                  staticStyle: {
                                    width: "80px",
                                    color: "#8698B7",
                                  },
                                  attrs: { placeholder: "名称", clearable: "" },
                                  on: {
                                    keyup: function ($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.setClassNameDiable(c, false)
                                    },
                                    blur: function ($event) {
                                      return _vm.setClassNameDiable(c, false)
                                    },
                                  },
                                  model: {
                                    value: c.className,
                                    callback: function ($$v) {
                                      _vm.$set(c, "className", $$v)
                                    },
                                    expression: "c.className",
                                  },
                                })
                              : _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      cursor: "pointer",
                                      color: "#8698B7",
                                    },
                                    on: {
                                      dblclick: function ($event) {
                                        return _vm.setClassNameDiable(c, true)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(c.className))]
                                ),
                            _c("el-input", {
                              staticStyle: { width: "60px", color: "#8698B7" },
                              attrs: { placeholder: "人数" },
                              model: {
                                value: c.studNum,
                                callback: function ($$v) {
                                  _vm.$set(c, "studNum", _vm._n($$v))
                                },
                                expression: "c.studNum",
                              },
                            }),
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "280px" },
                                attrs: {
                                  multiple: "",
                                  placeholder: "选择班级",
                                },
                                model: {
                                  value: c.sourceNames,
                                  callback: function ($$v) {
                                    _vm.$set(c, "sourceNames", $$v)
                                  },
                                  expression: "c.sourceNames",
                                },
                              },
                              _vm._l(_vm.classObjSelected[i], function (c, k) {
                                return _c("el-option", {
                                  key: k,
                                  attrs: {
                                    label: c.sourceName,
                                    value: c.sourceName,
                                  },
                                })
                              }),
                              1
                            ),
                            _c("span", { staticClass: "del-container" }, [
                              _c("i", {
                                staticClass: "el-icon-error",
                                on: {
                                  click: function ($event) {
                                    return _vm.deleteClass(i, j)
                                  },
                                },
                              }),
                            ]),
                          ],
                          1
                        )
                      : _vm._e()
                  }),
                  _vm.plusIconVisible[i][0]
                    ? _c("span", [
                        _c("i", {
                          staticClass: "el-icon-circle-plus",
                          on: {
                            click: function ($event) {
                              return _vm.addClass(i, 1)
                            },
                          },
                        }),
                      ])
                    : _vm._e(),
                ],
                2
              ),
            ]),
          ]),
        ])
      }),
      _c("div", { staticClass: "main" }, [
        _vm._m(4),
        _c(
          "div",
          { staticStyle: { "margin-top": "10px" } },
          [
            _c(
              "el-checkbox",
              {
                model: {
                  value: _vm.crossRegionClassSetting1.checked,
                  callback: function ($$v) {
                    _vm.$set(_vm.crossRegionClassSetting1, "checked", $$v)
                  },
                  expression: "crossRegionClassSetting1.checked",
                },
              },
              [_vm._v("C5")]
            ),
            _c("el-input", {
              staticStyle: { width: "100px", "margin-left": "10px" },
              attrs: { placeholder: "学生人数", size: "mini" },
              model: {
                value: _vm.crossRegionClassSetting1.studNum,
                callback: function ($$v) {
                  _vm.$set(_vm.crossRegionClassSetting1, "studNum", $$v)
                },
                expression: "crossRegionClassSetting1.studNum",
              },
            }),
            _c(
              "el-select",
              {
                staticStyle: { width: "100px", "margin-left": "20px" },
                attrs: { placeholder: "选择分区", size: "mini" },
                model: {
                  value: _vm.crossRegionClassSetting1.regionName,
                  callback: function ($$v) {
                    _vm.$set(_vm.crossRegionClassSetting1, "regionName", $$v)
                  },
                  expression: "crossRegionClassSetting1.regionName",
                },
              },
              [
                _c("el-option", {
                  attrs: { label: "分区一", value: "分区一" },
                }),
                _c("el-option", {
                  attrs: { label: "分区二", value: "分区二" },
                }),
              ],
              1
            ),
            _c("span", { staticStyle: { "margin-left": "20px" } }, [
              _vm._v("跨区人数"),
            ]),
            _c("el-input", {
              staticStyle: { width: "100px" },
              attrs: {
                placeholder: "跨区人数",
                size: "mini",
                min: "0",
                max: _vm.crossRegionClassSetting1.studNum,
                type: "number",
              },
              model: {
                value: _vm.crossRegionClassSetting1.crossRegionStudNum,
                callback: function ($$v) {
                  _vm.$set(
                    _vm.crossRegionClassSetting1,
                    "crossRegionStudNum",
                    _vm._n($$v)
                  )
                },
                expression: "crossRegionClassSetting1.crossRegionStudNum",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticStyle: { "margin-top": "10px" } },
          [
            _c(
              "el-checkbox",
              {
                model: {
                  value: _vm.crossRegionClassSetting2.checked,
                  callback: function ($$v) {
                    _vm.$set(_vm.crossRegionClassSetting2, "checked", $$v)
                  },
                  expression: "crossRegionClassSetting2.checked",
                },
              },
              [_vm._v("A-")]
            ),
            _c("el-input", {
              staticStyle: { width: "100px", "margin-left": "10px" },
              attrs: { placeholder: "学生人数", size: "mini" },
              model: {
                value: _vm.crossRegionClassSetting2.studNum,
                callback: function ($$v) {
                  _vm.$set(_vm.crossRegionClassSetting2, "studNum", $$v)
                },
                expression: "crossRegionClassSetting2.studNum",
              },
            }),
            _c(
              "el-select",
              {
                staticStyle: { width: "100px", "margin-left": "20px" },
                attrs: { placeholder: "选择分区", size: "mini" },
                model: {
                  value: _vm.crossRegionClassSetting2.regionName,
                  callback: function ($$v) {
                    _vm.$set(_vm.crossRegionClassSetting2, "regionName", $$v)
                  },
                  expression: "crossRegionClassSetting2.regionName",
                },
              },
              [
                _c("el-option", {
                  attrs: { label: "分区一", value: "分区一" },
                }),
                _c("el-option", {
                  attrs: { label: "分区二", value: "分区二" },
                }),
              ],
              1
            ),
            _c("span", { staticStyle: { "margin-left": "20px" } }, [
              _vm._v("跨区人数"),
            ]),
            _c("el-input", {
              staticStyle: { width: "100px" },
              attrs: {
                placeholder: "跨区人数",
                size: "mini",
                min: "0",
                max: _vm.crossRegionClassSetting2.studNum,
                type: "number",
              },
              model: {
                value: _vm.crossRegionClassSetting2.crossRegionStudNum,
                callback: function ($$v) {
                  _vm.$set(
                    _vm.crossRegionClassSetting2,
                    "crossRegionStudNum",
                    _vm._n($$v)
                  )
                },
                expression: "crossRegionClassSetting2.crossRegionStudNum",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticStyle: { "text-align": "center", "margin-top": "30px" } },
          [
            _c(
              "el-button",
              {
                staticStyle: {
                  "padding-left": "15px",
                  "padding-right": "15px",
                },
                attrs: { type: "primary" },
                on: { click: _vm.checkSettingSubmit },
              },
              [_vm._v("生成分班")]
            ),
          ],
          1
        ),
      ]),
      _c(
        "yue-dialog",
        {
          attrs: {
            title: "生成分班",
            visible: _vm.dialogVisible,
            width: "30%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              attrs: { "label-position": "right", "label-width": "100px" },
              nativeOn: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "记录名称：" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "请输入记录名称" },
                    model: {
                      value: _vm.DivideSettingVo.recordName,
                      callback: function ($$v) {
                        _vm.$set(_vm.DivideSettingVo, "recordName", $$v)
                      },
                      expression: "DivideSettingVo.recordName",
                    },
                  }),
                ],
                1
              ),
              _vm.recordId
                ? _c(
                    "el-form-item",
                    { attrs: { label: "类型：" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          model: {
                            value: _vm.changeType,
                            callback: function ($$v) {
                              _vm.changeType = $$v
                            },
                            expression: "changeType",
                          },
                        },
                        [
                          _c("el-radio", { attrs: { label: 0 } }, [
                            _vm._v("创建新记录"),
                          ]),
                          _c("el-radio", { attrs: { label: 1 } }, [
                            _vm._v("修改原记录"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            { staticStyle: { "margin-top": "50px", "text-align": "center" } },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.setDivideSetting },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "top" }, [
      _c("div", { staticClass: "step active" }, [
        _c("span", { staticClass: "icon" }, [
          _c("img", {
            staticStyle: { height: "30px" },
            attrs: { src: require("images/check_icon.png"), alt: "" },
          }),
        ]),
        _c("span", { staticClass: "text" }, [_vm._v("选择导入成绩成绩")]),
      ]),
      _c("div", { staticClass: "dots" }, [
        _c("span", { staticClass: "dot" }),
        _c("span", { staticClass: "dot" }),
        _c("span", { staticClass: "dot" }),
        _c("span", { staticClass: "dot" }),
        _c("span", { staticClass: "dot" }),
      ]),
      _c("div", { staticClass: "step" }, [
        _c("span", { staticClass: "icon" }, [
          _c("img", {
            staticStyle: { height: "30px" },
            attrs: { src: require("images/check_icon.png"), alt: "" },
          }),
        ]),
        _c("span", { staticClass: "text active" }, [_vm._v("设置规则")]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("span", [_vm._v("权重排序：")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "label" }, [
      _c("span", { staticClass: "icon" }, [
        _c("img", {
          staticStyle: { height: "14px" },
          attrs: { src: require("images/person_icon.png"), alt: "" },
        }),
      ]),
      _c("span", { staticClass: "text" }, [_vm._v("生源设置：")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "label" }, [
      _c("span", { staticClass: "icon" }, [
        _c("img", {
          staticStyle: { height: "14px" },
          attrs: { src: require("images/level_icon.png"), alt: "" },
        }),
      ]),
      _c("span", { staticClass: "text" }, [_vm._v("层级设置：")]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("span", [_vm._v("设置跨区班级：")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }